import { render, staticRenderFns } from "./side-menu.vue?vue&type=template&id=e5c3953e&"
import script from "./side-menu.vue?vue&type=script&lang=ts&"
export * from "./side-menu.vue?vue&type=script&lang=ts&"
import style0 from "./side-menu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBarNavIcon } from 'vuetify/lib/components/VAppBar';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VList } from 'vuetify/lib/components/VList';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VAppBarNavIcon,VDivider,VList,VNavigationDrawer,VToolbar})
